import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";

import { GlassMagnifier } from "react-image-magnifiers";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import { ParcelType, MediaType } from "../../../../enums/productEnum";

import { Modal, useMediaQuery, useTheme } from "@material-ui/core";
import {
  StyledArrowWrapper,
  StyledArrows,
  StyledCorouselWrapper,
  StyledFrame,
  StyledGrid,
  StyledLargeText,
  StyledLargeTxtCon,
  StyledLargeTxtImg,
  StyledNotAvailableImage,
  StyledProductImage,
  StyledWrapperGrid,
} from "../../../../pages/preview/components/details/ProductCarouselStyles";
import { StyledNoImgGrid } from "../../details/DetailsCarousel";
import PlayerSlide from "../../../videoPlayer/PlayerSlide";
import ZoomedCarousel from "../../../auction-version-2/auction/components/details/ZoomedCarousel";
import styled from "styled-components";

const StyledModal = styled(Modal)`
  display: flex;
  outline: none;
  align-items: center;
  justify-content: center;
`;

interface IProps {
  productData: any;
  medias: any;
  noRefresh?: boolean | undefined;
}

const ProductCarouselNew = (props: IProps) => {
  const { t } = useTranslation();
  const { medias, productData, noRefresh } = props;

  const [show, setShow] = useState<boolean>(true);

  useEffect(() => {
    if (!noRefresh) {
      setShow(false);
      if (medias?.length === 1) {
        setTimeout(() => {
          setShow(true);
        }, 50);
      } else {
        setShow(true);
      }
    }
  }, [medias]);

  // @ts-ignore
  const { parcelType } = { ...productData };
  const [zoomedCarousel, setZoomedCarousel] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0); // Start with the third media as active
  const theme = useTheme();
  const notSmallDevices = useMediaQuery(theme.breakpoints.between("md", "xl"));

  const openZoomedCarousel = () => {
    setZoomedCarousel(true);
  };

  const onClose = () => {
    setZoomedCarousel(false);
  };

  useEffect(() => {
    const handleEsc = (event: any) => {
      if (event.key === "Escape") {
        setZoomedCarousel(false);
      }
    };
    window.addEventListener("keydown", handleEsc);

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, []);

  const isParcelTypeDiamond = () => {
    return parcelType === ParcelType.DIAMOND;
  };
  const isParcelTypeJewellery = () => {
    return parcelType === ParcelType.JEWELLERY;
  };

  const isMediaTypePhoto = (item: any) => {
    return item && item?.mediaType === MediaType.PHOTO;
  };
  const isMediaTypeVideo = (item: any) => {
    return item && item?.mediaType === MediaType.VIDEO;
  };

  const checkMedias = () => {
    return medias !== undefined && medias !== null && medias.length > 0;
  };

  const checkPresignedUrl = (item: any) => {
    return (
      (item && item?.thumbnailPresignedUrl !== null) ||
      item?.presignedUrl !== null
    );
  };

  const checkThumbnailPresignedUrl = (item: any) => {
    return (
      (item && item?.thumbnailPresignedUrl === null) ||
      item?.presignedUrl === null
    );
  };

  const renderArrowPrev = (
    onClickHandler: () => void,
    hasPrev: boolean,
    label: string
  ) => {
    return (
      <StyledArrowWrapper
        onClick={onClickHandler}
        title={label}
        style={{ left: 0 }}
      >
        <StyledArrows
          src={`/images/controls/${
            hasPrev
              ? "left_arrow_round_edges.png"
              : "left_arrow_round_edges_disabled.png"
          }`}
        />
      </StyledArrowWrapper>
    );
  };

  const renderArrowNext = (
    onClickHandler: () => void,
    hasNext: boolean,
    label: string
  ) => {
    return (
      <StyledArrowWrapper
        onClick={onClickHandler}
        title={label}
        style={{ right: 0 }}
      >
        <StyledArrows
          src={`/images/controls/${
            hasNext
              ? "right_arrow_round_edges.png"
              : "right_arrow_round_edges_disabled.png"
          }`}
        />
      </StyledArrowWrapper>
    );
  };

  const renderImageNotAvailable = () => {
    return (
      <StyledNoImgGrid
        container={true}
        spacing={0}
        reserved={productData?.reserved}
      >
        <StyledNotAvailableImage>
          <StyledProductImage
            src={`/images/${
              isParcelTypeDiamond() || isParcelTypeJewellery()
                ? "default-diamond.png"
                : "default-parcel.png"
            }`}
          ></StyledProductImage>
        </StyledNotAvailableImage>
      </StyledNoImgGrid>
    );
  };

  const renderVideoNotAvailable = () => {
    return (
      <StyledGrid container={true} spacing={0}>
        <StyledNotAvailableImage>
          <StyledProductImage src="/images/video_not_available.png"></StyledProductImage>
        </StyledNotAvailableImage>
      </StyledGrid>
    );
  };

  const renderFullScreenView = (item: any) => {
    return (
      <StyledLargeTxtCon item={true} xs={12}>
        <StyledLargeTxtImg src="/images/video-enlarge.png"></StyledLargeTxtImg>
        <StyledLargeText
          onClick={() => {
            if (item.mediaType === MediaType.VIDEO) {
              openZoomedCarousel();
            } else {
              openZoomedCarousel();
            }
          }}
        >
          {t("common:preview:productDetail:viewFullScreen")}
        </StyledLargeText>
      </StyledLargeTxtCon>
    );
  };

  return (
    <>
      {checkMedias() ? (
        <StyledGrid container={true} spacing={0}>
          <StyledCorouselWrapper>
            {show && (
              <Carousel
                showStatus={false}
                showThumbs={false}
                showIndicators={false}
                thumbWidth={60}
                transitionTime={0}
                swipeable={false}
                renderArrowPrev={renderArrowPrev}
                renderArrowNext={renderArrowNext}
                onChange={(newIndex: number) => {
                  setActiveIndex(newIndex);
                }}
              >
                {medias.map((item: any, index: number) => (
                  <StyledWrapperGrid
                    key={index}
                    reserved={productData?.reserved}
                  >
                    {isMediaTypePhoto(item) ? (
                      <div>
                        {checkPresignedUrl(item) ? (
                          <div
                            onClick={() => {
                              openZoomedCarousel();
                            }}
                          >
                            <GlassMagnifier
                              imageSrc={`${item.thumbnailPresignedUrl}`}
                              magnifierSize="50%"
                              largeImageSrc={`${item.thumbnailPresignedUrl}`}
                            />
                          </div>
                        ) : (
                          renderImageNotAvailable()
                        )}
                      </div>
                    ) : (
                      <div>
                        {checkThumbnailPresignedUrl(item) ? (
                          renderVideoNotAvailable()
                        ) : (
                          <div>
                            {isMediaTypeVideo(item) ? (
                              <Grid container={true} spacing={0}>
                                {renderFullScreenView(item)}
                                <PlayerSlide
                                  url={`${item.presignedUrl}`}
                                  thumbnail={`${item.thumbnailPresignedUrl}`}
                                />
                              </Grid>
                            ) : (
                              <Grid container={true} spacing={0}>
                                {renderFullScreenView(item)}
                                {notSmallDevices ? (
                                  <StyledFrame
                                    src={`${item.presignedUrl}&sr=100`}
                                  />
                                ) : (
                                  <div id="new-wrapfreamDetailsCarousel">
                                    <StyledFrame
                                      id="new-scaled-frameDetailsCarousel"
                                      src={`${item.presignedUrl}&sr=100`}
                                      style={{ margin: "0px" }}
                                    />
                                  </div>
                                )}
                              </Grid>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </StyledWrapperGrid>
                ))}
              </Carousel>
            )}
          </StyledCorouselWrapper>
        </StyledGrid>
      ) : (
        renderImageNotAvailable()
      )}

      {zoomedCarousel && (
        <StyledModal open={zoomedCarousel} onClose={onClose}>
          <ZoomedCarousel
            medias={medias}
            onClose={onClose}
            parcelType={parcelType}
            activeIndex={activeIndex}
          />
        </StyledModal>
      )}
    </>
  );
};

export default React.memo(ProductCarouselNew);
